const initialState = {
  isOn: false
}


export const navigationReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_NAVIGATION": {
      return { ...state, isOn: action.data }
    }
    default:
      return state;

  }


};